<script>
    import { setContext } from "svelte";
    import { writable } from "svelte/store";
    import { touchAction } from "../../utils/dragMove";
    import { isEmptyObject } from "../../utils";
    export let autoplay = false;
    export let interval = 3000;
    export let defaultIndex = 0;
    const items = writable([]);
    let len = items.length;
    let cls = "sui-swiper";
    const step = 1;
    let indicatorIndex = defaultIndex;
    setContext("SwiperState", {
        items,
        add: (item) => {
            items.update((old) => {
                //默认选择第一个，如果后面设置了就取消第一个的选择
                if (old.length === defaultIndex + step) {
                    item.active = true;
                }
                return [...old, ...[item]];
            });
        },
    });

    function handleEnd(e) {
        console.log(e.detail.index);
        indicatorIndex = e.detail.index - 1;
    }

    $: {
        len = $items.length;
    }
</script>

{#if !isEmptyObject($$slots)}
    <div class={cls}>
        <div
            class={`${cls}-inner`}
            use:touchAction={{
                defaultIndex: defaultIndex + 1,
                direction: "horizontal",
                autoplay,
                interval,
            }}
            on:dragend={handleEnd}
        >
            <slot />
        </div>
        {#if $items.length > 0}
            <div class={`${cls}-indicator`}>
                <div class={`${cls}-indicator-inner`}>
                    {#each $items as item, i}
                        <span class:active={indicatorIndex === i} />
                    {/each}
                </div>
            </div>
        {/if}
    </div>
{/if}

<style lang="less">
    @import "./swiper.less";
</style>
